export default {
  all: [],
  current: null,
  externalEmployees: [],
  externalHardware: []
}
